import { httpsCallable } from 'firebase/functions';
import { functions } from '.';

// the agreements a customer accepts when an account is created - the funnel, /sign-up and the guest support chat
export const ACCOUNT_AGREEMENT_KEYS = ['TERMS', 'PRIVACY', 'COOKIE', 'COMMUNICATION', 'TELEHEALTH_CONSENT', 'READYRX_PRIVACY_PRACTICES'];

export const generateUserAgreements = async (userId, keys = [], ipAddress = null, signatureName = null) => {
    const func = httpsCallable(functions, 'generateuseragreements', { timeout: 6000000 });
    const result = await func({ userId, keys, ipAddress, signatureName });
    return result?.data;
};
